import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Icon } from '@nazka/nazka.mapframe.components'
import { useQuery } from '@tanstack/react-query'

import { NAV_ITEMS } from '@App/components/Nav/nav.constants'
import { navLinkClassNameFn } from '@App/components/Nav/nav.utils'
import { fetchMissionDataByProps } from '@services/data.service'

import './nav.styl'

function Nav() {
  const { activeProject } = useSelector(state => state.missionSetup)

  const { data: alerts } = useQuery({
    queryKey: ['alerts-all', activeProject?.id],
    queryFn: () => fetchMissionDataByProps(activeProject?.id, 'alert'),
    enabled: !!activeProject?.id,
  })

  return (
    <div className="nav">
      { NAV_ITEMS.map(({ pathName, icon, iconSize, badge, disabled }, i) => {
        if (!pathName) {
          return <hr key={i} />
        }

        return (
          <div key={pathName} className={`nav__item${disabled ? ' nav__item--disabled' : ''}`} title={disabled ? 'in development' : ''}>
            <NavLink className={navLinkClassNameFn} to={`/${pathName}`}>
              <Icon icon={icon} size={iconSize || '22px'} />
              {badge && !!alerts?.length && badge({ counter: alerts?.length || 0 })}
            </NavLink>
          </div>
        )
      })}
    </div>
  )
}

export default Nav
